const Type = {
  LAYER: {
    LANELET: "lanelet",
    LANE_MARKER: "lane_marker",
    VIRTUAL_LINE: "virtual_line",
    ROAD_EDGE: "road_edge",
    ROAD_EDGE: "road_edge",
    CURBSTONE: "curbstone",
  },
  ASSET: {
    OSM: "OSM",
    GEOJSON: "GEOJSON",
    GEOJSON_IMAGE: "CAMERA_IMAGE",
    KML: "KML",
    GLB: "GLB",
    JSON: "JSON",
    ZIP: "ZIP",
    RAR: "RAR",
    NONE: "NONE",
    CONFIG: "CONFIG",
    THREEDTILES: "THREEDTILES",
    CSV: "CSV",
    CZML: "CZML",
    KMZ: "KMZ",
    IMAGERY: "IMAGERY",
  },
  STORAGE: {
    STATE_TIMELINE: "state_timeline",
    STATE_GRID: "state_grid",
    USERINFO: "user_info",
    DEFAULT_GEOJSON_STYLE: "default_geojson_style",
    DEFAULT_OSM_STYLE: "default_osm_style",
    BASIC_GEOJSON_STYLE: "basic_geojson_style",
    IMPORT_URLS: "import_urls",
    FEATURE_CACHED: "feature_cached",
    SELECTION_TYPE: "selection_type",
  },
  ROLE: {
    SUPER_ADMIN: "superadmin",
    ADMIN: "admin",
    ANNOTATOR: "annotator",
    REVIEWER: "reviewer",
    VIEWER: "viewer",
    DIGITIZER: "digitizer",
  },
  SCENE: {
    SCENE_3D: "3D",
    SCENE_2D: "2D",
    SCENE_COLUMBUS: "COLUMBUS",
  },
  CAMERA: {
    ENTITY: "entity",
    LOCATION: "location",
    DATASOURCE: "dataSource",
  },
  NOTIFICATION: {
    INFO: "info",
    ERROR: "error",
    SUCCESS: "success",
    WARNING: "warning",
  },
  CURSOR: {
    DEFAULT: "default",
    PLUS: "adding",
    GRAB: "moving",
    CUT: "cut",
  },
  MODE: {
    EDITE: "edit",
    VIEW: "view",
    POINTCLOUD: "pointcloud",
  },
  HOTKEYS: {
    ACTIVE_EDIT_LAYER: "ACTIVE_EDIT_LAYER",
    CREATE_LANELET: "CREATE_LANELET",
    SAVE_LAYER_TO_SERVER: "SAVE_LAYER_TO_SERVER",
    DELETE_LAYER: "DELETE_LAYER",
    TOGGLE_LABEL_VISIBILITY: "TOGGLE_LABEL_VISIBILITY",
    TOGGLE_LAYER_VISIBILITY: "TOGGLE_LAYER_VISIBILITY",
    ZOOM_TO_EXTENT: "ZOOM_TO_EXTENT",
    SAVE_TO_DATABASE: "SAVE_TO_DATABASE",
    TOGGLE_DIRECTION_VISIBILITY: "TOGGLE_DIRECTION_VISIBILITY",
    SELECT_LANELET: "SELECT_LANELET",
    TOGGLE_ASSOCIATION: "TOGGLE_ASSOCIATION",
    LINE_INTERSECT_MEASURE: "LINE_INTERSECT_MEASURE",
    SELECT_RECTANGLE: "SELECT_RECTANGLE",
    SPLIT: "SPLIT",
    SPLIT_AUTO: "SPLIT_AUTO",
    UNDO: "UNDO",
    DELETE: "DELETE",
    TOGGLE_AUTO_SNAP: "TOGGLE_AUTO_SNAP",
    TOPOLOGY_INTERSECTION_POINTS: "TOPOLOGY_INTERSECTION_POINTS",
    TOPOLOGY_INTERSECTION_POINTS_ALL: "TOPOLOGY_INTERSECTION_POINTS_ALL",
    TOPOLOGY_DANGLING_LINES: "TOPOLOGY_DANGLING_LINES",
    SAVE_EDITING: "SAVE_EDITING",
    DELETE_SELECTED: "DELETE_SELECTED",
    REVERSE_WAYPOINTS: "REVERSE_WAYPOINTS",
    ADD_NEW_FEATURE: "ADD_NEW_FEATURE",
    REDO: "REDO",
    JOIN_LINES: "JOIN_LINES",
    SPLINE: "SPLINE",
    PARALLEL: "PARALLEL",
    CANCEL_EDITING: "CANCEL_EDITING",
    SPLITEDIT: "SPLITEDIT",
    UNDOEDIT: "UNDOEDIT",
    TOGGLE_SOME_VISIBILITY: "TOGGLE_SOME_VISIBILITY",
    TOGGLE_ROUTE_VISIBILITY: "TOGGLE_ROUTE_VISIBILITY",
    OPEN_SEARCH_GEOJSON: "OPEN_SEARCH_GEOJSON",
    RESET_SEARCH_GEOJSON: "RESET_SEARCH_GEOJSON",
    PAN_UP: "PAN_UP",
    PAN_DOWN: "PAN_DOWN",
    PAN_LEFT: "PAN_LEFT",
    PAN_RIGHT: "PAN_RIGHT",
    ZOOM_IN: "ZOOM_IN",
    ZOOM_OUT: "ZOOM_OUT",
    MOVE_FORWARD: "MOVE_FORWARD",
    MOVE_BACKWARD: "MOVE_BACKWARD",
    MOVE_LEFT: "MOVE_LEFT",
    MOVE_RIGHT: "MOVE_RIGHT",
    HEIGHT_UP: "HEIGHT_UP",
    HEIGHT_DOWN: "HEIGHT_DOWN",
    ROTATE_UP: "ROTATE_UP",
    ROTATE_DOWN: "ROTATE_DOWN",
    ROTATE_LEFT: "ROTATE_LEFT",
    ROTATE_RIGHT: "ROTATE_RIGHT",
    TOGGLE_LANE_MARKER_EDIT: "TOGGLE_LANE_MARKER_EDIT",
    TOGGLE_VIRTUAL_LAYER_EDIT: "TOGGLE_VIRTUAL_LAYER_EDIT",
    TOGGLE_ROAD_EDGE_EDIT: "TOGGLE_ROAD_EDGE_EDIT",
    TOGGLE_TRAFFIC_SIGN_BOX_EDIT: "TOGGLE_TRAFFIC_SIGN_BOX_EDIT",
    TOGGLE_STOP_LINE_EDIT: "TOGGLE_STOP_LINE_EDIT",
    TOGGLE_CURBSTONE_EDIT: "TOGGLE_CURBSTONE_EDIT",
    AUTO_SELECT: "AUTO_SELECT",
    TOGGLE_ASSOCIATION_FAST: "TOGGLE_ASSOCIATION_FAST",
    SAVE_PROJECT: "SAVE_PROJECT",
    MEASURE_DISTANCE: "MEASURE_DISTANCE",
    DESELECT: "DESELECT",
    AUTOSKETCHER: "AUTOSKETCHER",
    DRIVEWAY: "DRIVEWAY",
    ALIGN_ENDPOINTS: "ALIGN_ENDPOINTS",
    AUTO_SNAP_CLUSTER: "AUTO_SNAP_CLUSTER",
    SWITCH_LANELET_SIDES: "SWITCH_LANELET_SIDES",
    SWITCH_LANELET_TURN_DIRECTION: "SWITCH_LANELET_TURN_DIRECTION",
  },
};

export default Type;
